export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5603.5bc8c5ae.jpg";